<script setup lang="ts"></script>

<template>
  <div class="tw-flex-1">
    <slot />
  </div>
  <div class="tw-h-auto">
    <slot name="footer" />
  </div>
</template>

<style scoped></style>
